module.exports = __webpack_public_path__ + "img/adsamurai.e860c8dd.svg";